import { type Html, html, rune, View } from 'rune-ts';
import klass from './BottomSection.module.scss';
import { font } from '../../../../../shared/typography';
import { ButtonCtaLanding } from '../../../../../shared/components/atoms/ButtonCtaLanding/ButtonCtaLanding';
import { commerce_creator_apply_url } from '../../constant';

export class BottomSection extends View {
  ctaButton = new ButtonCtaLanding({
    href: commerce_creator_apply_url,
    type: 'black',
    label: '커머스 크리에이터 지원하기',
    klass: `${klass.submit}`,
    target: '_blank',
  });

  constructor() {
    super({});
  }

  override template(): Html {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;
    const texts = {
      title: is_mobile
        ? html.preventEscape(`커머스 크리에이터 지원하면<br /> 이렇게 진행돼요!`)
        : '커머스 크리에이터 지원하면 이렇게 진행돼요!',
      desc: is_mobile
        ? html.preventEscape(`커머스 크리에이터 지원서 신청 → 마플샵 검토 및 선정<br/>
            → 대면/화상 미팅 → 계약 → 브랜드 매칭<br/>
            → 브랜드 커머스 진행 → 정산`)
        : html.preventEscape(
            `커머스 크리에이터 지원서 신청 → 마플샵 검토 및 선정 → 대면/화상 미팅<br/>→ 계약 → 브랜드 매칭 → 브랜드 커머스 진행 → 정산`,
          ),
    };
    return html`
      <section class="${klass.bottom}">
        <div class="${klass.content_wrapper}">
          <div class="${klass.content}">
            <div class="${font('36_bold', '28_bold')}">${texts.title}</div>
            <div class="${font('24_bold', '16_bold')}">${texts.desc}</div>
          </div>
          ${this.ctaButton}
        </div>
      </section>
    `;
  }
}

// →
